<template>
  <v-app :dark="dark">
    <Snackbar></Snackbar>
    <v-navigation-drawer
            app
            v-if="isAuthenticated && shouldShowDrawer"
            v-model="drawer"
            class="primary"
            dark
            fixed
    >
      <v-list dense>
        <v-list>
          <v-list-tile avatar>
            <v-list-tile-avatar size="75px">
              <img :src="getProfile.avatar">
            </v-list-tile-avatar>
          </v-list-tile>
          <v-list
                  link
                  two-line
          >
            <v-list-tile avatar>
              <v-list-tile-content>
                <v-list-tile-title v-if="getProfile.is_superuser === true" class="text--white">{{$t('SuperAdministrador')}}</v-list-tile-title>
                <v-list-tile-title v-if="getProfile.roll === 5" class="text--white">{{$t('Administrador')}}</v-list-tile-title>
                <v-list-tile-title v-if="getProfile.roll === 4" class="text--white">{{ parkAdminTitle }}</v-list-tile-title>
                <v-list-tile-title v-if="getProfile.roll === 2" class="text--white">{{$t('Vigilante')}}</v-list-tile-title>
                <v-list-tile-title v-if="getProfile.roll === 9" class="text--white">{{$t('Guardia')}}</v-list-tile-title>
                <v-list-tile-title v-if="getProfile.roll === 1" class="text--white">{{$t('Empleado')}}</v-list-tile-title>
                <v-list-tile-title v-if="getProfile.roll === 15" class="text--white">{{$t('proveedor')}}</v-list-tile-title>
                <v-list-tile-title v-if="getProfile.roll === 11" class="text--white">{{$t('empleado_proveedor')}}</v-list-tile-title>
                <v-list-tile-title v-if="getProfile.roll === 3" class="text--white">{{$t('Vigilante_Parque')}}</v-list-tile-title>
                <v-list-tile-sub-title  class="title">{{getProfile.first_name}} {{getProfile.last_name}}</v-list-tile-sub-title>
                <v-list-tile-sub-title>{{getProfile.email}}</v-list-tile-sub-title>
              </v-list-tile-content>
              <v-list-tile-action>
                <v-btn
                        icon
                        @click.stop="drawer = !drawer"
                >
                  <v-icon>chevron_left</v-icon>
                </v-btn>
              </v-list-tile-action>
            </v-list-tile>
          </v-list>
        </v-list>
        <v-list-tile
          class="tile"
          active-class="blue-grey darken-1 white--text"
          router
          to="/home"
        >
          <v-list-tile-action>
            <v-icon medium>home</v-icon>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title><h3>Inicio</h3></v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
        <div v-if="
                getProfile.is_superuser == true
                && getProfile.roll == 0
                && getProfile.is_staff == false">
          <SuperAdmin></SuperAdmin>
        </div>
        <div v-else-if="
                getProfile.roll == 5
                && getProfile.is_superuser == false
                && getProfile.is_staff == false">
          <Admin></Admin>
        </div>
        <div v-else-if="
                getProfile.roll == 15
                && getProfile.is_superuser == false
                && getProfile.is_staff == false">
          <AdminProveedor></AdminProveedor>
        </div>
        <div v-else-if="
                getProfile.roll == 4
                && getProfile.is_superuser == false
                && getProfile.is_staff == false">
          <AdminParque></AdminParque>
        </div>
        <div v-else-if="
                getProfile.roll == 2
                && getProfile.is_superuser == false
                && getProfile.is_staff == false">
          <Vigilante></Vigilante>
        </div>
        <div v-else-if="
                getProfile.roll == 1
                && getProfile.is_superuser == false
                && getProfile.is_staff == false">
          <Empleado></Empleado>
        </div>
        <div v-else-if="
                getProfile.roll == 11
                && getProfile.is_superuser == false
                && getProfile.is_staff == false">
          <EmpleadoProveedor></EmpleadoProveedor>
        </div>
        <div v-else-if="
                getProfile.roll === 3
                && getProfile.is_superuser == false
                && getProfile.is_staff == false">
          <VigilanteParque></VigilanteParque>
        </div>
        <div v-else-if="
                getProfile.roll === 9
                && getProfile.is_superuser == false
                && getProfile.is_staff == false">
          <Guardia></Guardia>
        </div>
        <div v-else-if="
                getProfile.roll == 8
                && getProfile.is_superuser == false
                && getProfile.is_staff == false">
          <Admin></Admin>
        </div>
      </v-list>
    </v-navigation-drawer>
    <v-toolbar app dark color="primary">
      <v-toolbar-side-icon
              v-if="isAuthenticated && shouldShowDrawer"
              @click="drawer = !drawer"
      ></v-toolbar-side-icon>

      <v-toolbar-title
              class="white--text">
                <span>
                    <strong>
                        <router-link :to="{ name: 'home'}" class="text">
                            {{$t('intrare_empresa')}}
                        </router-link>
                    </strong>
                </span>
        <span v-if="isSecurityGuardWithoutShift" class="ml-3" style="font-size: 12px; opacity: 0.85;">
          <v-icon small dark>lock</v-icon> Inicia tu turno para acceder a la aplicación
        </span>
      </v-toolbar-title>
      <v-spacer></v-spacer>
<!--      <v-tooltip bottom>-->
<!--        <template v-slot:activator="{ on }">-->
<!--          <v-btn-->
<!--                  dark-->
<!--                  v-on="on"-->
<!--                  v-if="isAuthenticated"-->
<!--                  icon-->
<!--                  large-->
<!--                  @click="help()"-->
<!--          >-->
<!--            <v-icon>-->
<!--              report-->
<!--            </v-icon>-->
<!--          </v-btn>-->
<!--        </template>-->
<!--        <span>{{$t('tooltip_help')}}</span>-->
<!--      </v-tooltip>-->
      <template>
        <div class="text-xs-center">
          <v-menu
              v-if="isAuthenticated"
              v-model="menu"
              :close-on-content-click="false"
              :nudge-width="200"
              offset-x
          >
            <template v-slot:activator="{ on }">
              <v-btn
                  dark
                  v-on="on"
                  v-if="isAuthenticated"
                  icon
                  large
              >
                <v-icon>
                  report
                </v-icon>
              </v-btn>
            </template>
            <v-card max-width="300px">
              <v-list>
                <v-list-tile>
                  <v-list-tile-content>
                    <v-list-tile-title>Intrare</v-list-tile-title>
                    <v-list-tile-sub-title>{{$t('tooltip_help')}}</v-list-tile-sub-title>
                  </v-list-tile-content>
                </v-list-tile>
              </v-list>
              <v-divider></v-divider>
              <v-card-text  align="center">
                <v-flex>{{$t('msg_support')}}</v-flex>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="primary" @click="menu = false">{{$t('aceptar')}}</v-btn>
              </v-card-actions>
            </v-card>
          </v-menu>
        </div>
      </template>
<!--      <v-btn-->
<!--              icon-->
<!--              large-->
<!--              @click="setColor()"-->
<!--      >-->
<!--        <v-icon>-->
<!--          invert_colors-->
<!--        </v-icon>-->
<!--      </v-btn>-->
      <v-btn
              icon
              large
              @click="setLocale('es')"
      >
        <v-avatar
                size="32px"
                item
        >
          <div style="font-size:25px">
            <flag iso="mx">
            </flag>
          </div>
        </v-avatar>
      </v-btn>
      <v-btn
              icon
              large
              @click="setLocale('en')"
      >
        <v-avatar
                size="32px"
                item
        >
          <div style="font-size:25px">
            <flag iso="us">
            </flag>
          </div>
        </v-avatar>
      </v-btn>
      <NotificationCenter v-if="isAuthenticated" />
      <v-btn icon v-if="isAuthenticated" @click="logout()">
        <v-icon>exit_to_app</v-icon>
      </v-btn>
    </v-toolbar>
    <v-content>
      <v-container fluid>
        <router-view/>
      </v-container>
    </v-content>
    <!-- DEBUG: Remover condición temporalmente para ver si modal aparece -->
    <WebsocketEventModal></WebsocketEventModal>
    <footer>
      <Foot/>
    </footer>
  </v-app>
</template>

<script>
import { USER_REQUEST } from '@/store/actions/user'
import { mapGetters} from 'vuex'
import { AUTH_LOGOUT } from '@/store/actions/auth'
import Snackbar from '@/components/snackbar.vue'
import SuperAdmin from '@/components/panel/super_admin.vue'
import Admin from '@/components/panel/admin.vue'
import AdminProveedor from '@/components/panel/admin_proveedor.vue'
import AdminParque from '@/components/panel/admin_parque.vue'
import Vigilante from '@/components/panel/vigilante.vue'
import Guardia from '@/components/panel/guardia.vue'
import Empleado from  '@/components/panel/empleado.vue'
import EmpleadoProveedor from  '@/components/panel/empleado_proveedor.vue'
import VigilanteParque from  '@/components/panel/vigilante_parque.vue'
import Foot from '@/components/Foot.vue'
import WebsocketEventModal from '@/components/WebsocketEventModal.vue'
import WebSocketService from '@/services/websocketService'
import NotificationCenter from '@/components/notifications/NotificationCenter.vue'

  export default {
    name: 'ControlAccesos',
    data () {
      return {
        drawer: true,
        mini: true,
        right: null,
        dark: false,
        fav: true,
        menu: false,
        hints: true,
        websocketService: null,
      }
    },
    methods: {
      logout: function () {
        this.destroyChatbot()
        // Desconectar WebSocket al salir
        if (this.websocketService) {
          this.websocketService.disconnect()
        }
        localStorage.removeItem('id_caseta');
        localStorage.removeItem('id_parque');
        localStorage.removeItem('cam_devices')
        localStorage.removeItem('qr_devices')
        this.$store.dispatch(AUTH_LOGOUT).then(() => this.$router.push('/'))
      },
      setLocale(locale){
        this.$i18n.locale = locale
        this.$store.commit('change_language', locale)
      },
      /**
       * Inicializar WebSocket para escuchar eventos de QR
       */
      initializeWebSocket() {
        const profile = this.$store.getters.getProfile
        
        // Verificar que el usuario esté autenticado
        if (!profile || !profile.username) {
          return
        }

        // Validar que sea vigilante (roll === 2)
        if (profile.roll !== 2) {
          return
        }

        // Verificar si enable_parking está activo en perfil o empresa
        const hasParking = profile.enable_parking === true || (profile.empresa && profile.empresa.enable_parking === true)
        if (!hasParking) {
          return
        }

        // Obtener nombre de la empresa - intentar múltiples campos
        let companyName = null
        
        if (profile.name_company) {
          companyName = profile.name_company
        } else if (profile.empresa && profile.empresa.name) {
          companyName = profile.empresa.name
        } else if (profile.empresa_name) {
          companyName = profile.empresa_name
        } else if (profile.company_name) {
          companyName = profile.company_name
        }
        
        if (!companyName) {
          console.warn('[WebSocket] No se encontró nombre de empresa en profile')
          return
        }

        // Extraer solo letras del nombre de la empresa (ej: "Toluca 2000" => "Toluca")
        // y convertir a minúsculas (ej: "toluca")
        companyName = companyName.replace(/[^a-zA-Z]/g, '').toLowerCase()
        
        console.log('[WebSocket] Nombre de empresa procesado:', companyName)

        if (!companyName) {
          console.warn('[WebSocket] Nombre de empresa vacío después del procesamiento')
          return
        }

        console.log('[WebSocket] Conectando con empresa:', companyName)
        this.websocketService = new WebSocketService(this.$store)
        this.websocketService.connect(companyName)
      },
      /**
       * Inicializar el Asistente Virtual (Chatbot) sólo para usuarios autenticados
       */
      initChatbot(profile) {
        if (!this.isAuthenticated || !profile || !profile.email) {
          this.destroyChatbot()
          return
        }

        // Mapear rol a nombre descriptivo
        let rolNombre = "Usuario de Empresa"
        if (profile.is_superuser) rolNombre = "SuperAdministrador"
        else if (profile.roll === 5) rolNombre = "Administrador General"
        else if (profile.roll === 4) rolNombre = profile.is_building ? "Administrador de Edificio Corporativo" : "Administrador de Parque"
        else if (profile.roll === 2) rolNombre = "Vigilante"
        else if (profile.roll === 3) rolNombre = "Vigilante de Parque"
        else if (profile.roll === 9) rolNombre = "Guardia de Seguridad"
        else if (profile.roll === 1) rolNombre = "Empleado"
        else if (profile.roll === 15) rolNombre = "Proveedor / Transportista"
        else if (profile.roll === 11) rolNombre = "Empleado de Proveedor"

        const companyName = profile.name_company || (profile.empresa && profile.empresa.name) || profile.empresa_name || ""

        const userData = {
          name: ((profile.first_name || '') + ' ' + (profile.last_name || '')).trim() || profile.username || 'Usuario',
          email: profile.email,
          phone: profile.celular || profile.phone || '',
          role: rolNombre,
          company: companyName
        }

        const chatbotBackend = process.env.VUE_APP_CHATBOT_URL || "http://localhost:5050"

        // Si ya está instanciado, actualizar datos de sesión
        if (window.intrareWidgetInstance) {
          if (typeof window.intrareWidgetInstance.updateUser === 'function') {
            window.intrareWidgetInstance.updateUser(userData)
          }
          return
        }

        const mountWidget = () => {
          if (window.IntrareChatWidget && !window.intrareWidgetInstance) {
            window.intrareWidgetInstance = new window.IntrareChatWidget({
              backendUrl: chatbotBackend,
              area: "empresa",
              user: userData
            })
          }
        }

        if (window.IntrareChatWidget) {
          mountWidget()
        } else {
          // Inyectar el script del widget dinámicamente si no existe
          let script = document.getElementById("intrare-chat-script")
          if (!script) {
            script = document.createElement("script")
            script.id = "intrare-chat-script"
            script.src = `${chatbotBackend}/widget.js?v=${Date.now()}`
            script.setAttribute("data-manual-init", "true")
            script.onload = mountWidget
            document.head.appendChild(script)
          } else {
            script.addEventListener("load", mountWidget)
          }
        }
      },
      /**
       * Remover y destruir el chatbot al cerrar sesión
       */
      destroyChatbot() {
        if (window.intrareWidgetInstance) {
          if (typeof window.intrareWidgetInstance.destroy === 'function') {
            window.intrareWidgetInstance.destroy()
          }
          window.intrareWidgetInstance = null
        }
        const root = document.getElementById("intrare-chat-widget-root")
        if (root) root.remove()
      }
    },
    components:{
      Snackbar,
      SuperAdmin,
      Admin,
      AdminProveedor,
      AdminParque,
      Vigilante,
      Guardia,
      Empleado,
      EmpleadoProveedor,
      VigilanteParque,
      Foot,
      WebsocketEventModal,
      NotificationCenter
    },
    computed: {
      ...mapGetters(['isAuthenticated', 'getProfile']),
      ...mapGetters('security', ['getActiveShift']),
      isGuardiaWithParking() {
        const profile = this.getProfile
        // Verificar que sea guardia (roll === 9) y tenga parking habilitado
        const isGuardia = profile && profile.roll === 9
        const hasParking = profile && (profile.enable_parking || (profile.empresa && profile.empresa.enable_parking))
        return isGuardia && hasParking
      },
      isSecurityGuard() {
        return !!(this.getProfile && this.getProfile.roll === 9)
      },
      isSecurityGuardWithoutShift() {
        return this.isSecurityGuard && !this.getActiveShift
      },
      shouldShowDrawer() {
        // Todos los roles ven el sidemenu, EXCEPTO guardias (roll 9) sin turno activo
        if (!this.isSecurityGuard) return true
        return !!this.getActiveShift
      },
      parkAdminTitle() {
        const profile = this.getProfile || {}
        return profile.is_building ? 'Administrador de Edificio Corporativo' : this.$t('AdministradorParque')
      }
    },
    watch: {
      getProfile: {
        handler(profile) {
          if (profile && profile.email && this.isAuthenticated) {
            this.initChatbot(profile)
          }
        },
        immediate: true
      },
      isAuthenticated(val) {
        if (!val) {
          this.destroyChatbot()
        } else if (this.getProfile && this.getProfile.email) {
          this.initChatbot(this.getProfile)
        }
      }
    },
    created: function () {
      if (this.$store.getters.isAuthenticated) {
          this.$store.dispatch(USER_REQUEST).then(() => {
            // Si es guardia (roll 9), sincronizar el turno activo con el servidor
            // (el store ya se hidrata de localStorage al cargar, esto solo confirma/corrige)
            if (this.getProfile && this.getProfile.roll === 9) {
              this.$store.dispatch('security/FETCH_ACTIVE_SHIFT', this.$store.getters.getToken)
            }
            // Inicializar WebSocket y Chatbot después de cargar el perfil
            this.$nextTick(() => {
              this.initializeWebSocket()
              if (this.getProfile && this.getProfile.email) {
                this.initChatbot(this.getProfile)
              }
            })
          })
      }
    },
    destroyed: function () {
      this.destroyChatbot()
      // Limpiar WebSocket al destruir el componente
      if (this.websocketService) {
        this.websocketService.disconnect()
      }
    }
  }

</script>

<style scoped>
    .text {
        font-size: 10;
        font-family: "Roboto", sans-serif;
        color: #ffffff;
        text-decoration:none
    }
    .text:hover {
        font-size: 10;
        font-family: "Roboto", sans-serif;
        color: #ffffff;
        text-decoration:none
    }
</style>

<style>
    /* Vuetify pinta un fondo gris (#424242) por defecto en los v-list dentro de
       drawers oscuros (theme--dark). Sin esto, ese gris tapa el azul primary
       del v-navigation-drawer. */
    .v-navigation-drawer.primary .theme--dark.v-list {
        background: transparent !important;
    }
</style>
